import type { HTMLChakraProps } from '@chakra-ui/react'
import { chakra } from '@chakra-ui/react'

export const Marketplace = (props: HTMLChakraProps<'svg'>) => (
  <chakra.svg
    height='auto'
    width='auto'
    viewBox='0 0 625 537'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <rect x='44' width='537' height='537' rx='24' fill='#D9D9D9' fill-opacity='0.03' />
    <rect x='387.5' y='64.5' width='236' height='103' rx='22.5' fill='#0C0E14' />
    <rect x='410' y='87' width='71' height='10' rx='5' fill='#3BE0FF' />
    <rect x='410' y='111' width='191' height='12' rx='6' fill='#1E2432' />
    <rect x='410' y='133' width='90.5' height='12' rx='6' fill='#1E2432' />
    <rect x='510.5' y='133' width='90.5' height='12' rx='6' fill='#1E2432' />
    <rect x='387.5' y='64.5' width='236' height='103' rx='22.5' stroke='white' stroke-width='3' />
    <rect x='387.5' y='198.5' width='236' height='103' rx='22.5' fill='#0C0E14' />
    <rect x='410' y='221' width='71' height='10' rx='5' fill='#FF5C00' />
    <rect x='410' y='245' width='191' height='12' rx='6' fill='#1E2432' />
    <rect x='410' y='267' width='90.5' height='12' rx='6' fill='#1E2432' />
    <rect x='510.5' y='267' width='90.5' height='12' rx='6' fill='#1E2432' />
    <rect x='387.5' y='198.5' width='236' height='103' rx='22.5' stroke='white' stroke-width='3' />
    <rect x='387.5' y='332.5' width='236' height='103' rx='22.5' fill='#0C0E14' />
    <rect x='410' y='355' width='71' height='10' rx='5' fill='#F6E05E' />
    <rect x='410' y='379' width='191' height='12' rx='6' fill='#1E2432' />
    <rect x='410' y='401' width='90.5' height='12' rx='6' fill='#1E2432' />
    <rect x='510.5' y='401' width='90.5' height='12' rx='6' fill='#1E2432' />
    <rect x='387.5' y='332.5' width='236' height='103' rx='22.5' stroke='white' stroke-width='3' />
    <rect x='1.5' y='135.5' width='236' height='229' rx='22.5' fill='#0C0E14' />
    <rect x='24' y='158' width='71' height='10' rx='5' fill='#00CD98' />
    <rect x='24' y='192' width='191' height='12' rx='6' fill='#1E2432' />
    <rect x='24' y='214' width='90.5' height='12' rx='6' fill='#1E2432' />
    <rect x='124.5' y='214' width='90.5' height='12' rx='6' fill='#1E2432' />
    <rect x='24' y='250' width='191' height='12' rx='6' fill='#1E2432' />
    <rect x='24' y='272' width='191' height='12' rx='6' fill='#1E2432' />
    <rect x='24' y='294' width='191' height='12' rx='6' fill='#1E2432' />
    <rect x='24' y='330' width='191' height='12' rx='6' fill='#1E2432' />
    <rect x='1.5' y='135.5' width='236' height='229' rx='22.5' stroke='white' stroke-width='3' />
    <path
      d='M361.667 111C361.667 113.946 364.054 116.333 367 116.333C369.946 116.333 372.333 113.946 372.333 111C372.333 108.054 369.946 105.667 367 105.667C364.054 105.667 361.667 108.054 361.667 111ZM244 257H292.737V255H244V257ZM309.737 240V127H307.737V240H309.737ZM324.737 112H367V110H324.737V112ZM309.737 127C309.737 118.716 316.453 112 324.737 112V110C315.348 110 307.737 117.611 307.737 127H309.737ZM292.737 257C302.126 257 309.737 249.389 309.737 240H307.737C307.737 248.284 301.021 255 292.737 255V257Z'
      fill='#1E2B64'
    />
    <path
      d='M361.667 391C361.667 388.054 364.054 385.667 367 385.667C369.946 385.667 372.333 388.054 372.333 391C372.333 393.946 369.946 396.333 367 396.333C364.054 396.333 361.667 393.946 361.667 391ZM244 255H292.737V257H244V255ZM309.737 272V375H307.737V272H309.737ZM324.737 390H367V392H324.737V390ZM309.737 375C309.737 383.284 316.453 390 324.737 390V392C315.348 392 307.737 384.389 307.737 375H309.737ZM292.737 255C302.126 255 309.737 262.611 309.737 272H307.737C307.737 263.716 301.021 257 292.737 257V255Z'
      fill='#1E2B64'
    />
    <path
      d='M361.667 256C361.667 258.946 364.054 261.333 367 261.333C369.946 261.333 372.333 258.946 372.333 256C372.333 253.054 369.946 250.667 367 250.667C364.054 250.667 361.667 253.054 361.667 256ZM245 257H247.033V255H245V257ZM251.1 257H255.167V255H251.1V257ZM259.233 257H263.3V255H259.233V257ZM267.367 257H271.433V255H267.367V257ZM275.5 257H279.567V255H275.5V257ZM283.633 257H287.7V255H283.633V257ZM291.767 257H295.833V255H291.767V257ZM299.9 257H303.967V255H299.9V257ZM308.033 257H312.1V255H308.033V257ZM316.167 257H320.233V255H316.167V257ZM324.3 257H328.367V255H324.3V257ZM332.433 257H336.5V255H332.433V257ZM340.567 257H344.633V255H340.567V257ZM348.7 257H352.767V255H348.7V257ZM356.833 257H360.9V255H356.833V257ZM364.967 257H367V255H364.967V257Z'
      fill='#1E2B64'
    />
  </chakra.svg>
)
